import React from 'react';
import {useFieldArray, UseFormMethods, useWatch} from 'react-hook-form';
import {orderNumberRegex} from '../../../../utils/orderNumber';
import RadioButton from '../../../Forms/Inputs/RadioButton';
import RadioGroup from '../../../Forms/Inputs/RadioGroup';
import {IconSize} from '../../../Icon/Icon';
import {GenericIconName} from '../../../Icon/IconName';
import {FormDataRaw, FormErrors} from '../types';
import {
  AddButtonIcon,
  AddOrderNumberButton,
  FormSection,
  StyledTextInput,
} from './styled';

interface Props {
  register: UseFormMethods['register'];
  onChange: (val: string) => void;
  labels: {
    yes: string;
    no: string;
    is_question_about_order: string;
    required: string;
    add_order: string;
    order_number: string;
    order_number_invalid: string;
    order_number_example: string;
  };
  control: UseFormMethods['control'];
  isOrder: boolean;
  errors: FormErrors;
}

export const OrderRelatedSection = ({
  register,
  onChange,
  labels,
  control,
  isOrder,
  errors,
}: Props) => {
  const {fields: orderNumberFields, append: appendOrderNumber} = useFieldArray({
    control,
    name: 'orderNumber',
  });

  const values: FormDataRaw['orderNumber'] | undefined = useWatch({
    control,
    name: 'orderNumber',
  });

  return (
    <>
      <FormSection>
        <RadioGroup
          label={labels.is_question_about_order}
          onValueChange={onChange}
        >
          <RadioButton
            ref={register()}
            name={'isOrder'}
            label={labels.yes}
            value={'true'}
            date-testid="hcRadioIsOrderTrue"
          />
          <RadioButton
            ref={register()}
            name={'isOrder'}
            label={labels.no}
            value={'false'}
            date-testid="hcRadioIsOrderFalse"
          />
        </RadioGroup>
      </FormSection>

      <FormSection hidden={!isOrder}>
        {orderNumberFields.map((field, index) => {
          return (
            <div key={field.id}>
              <StyledTextInput
                ref={register({
                  pattern: {
                    value: orderNumberRegex,
                    message: labels.order_number_invalid,
                  },
                  required:
                    isOrder && index === 0 ? labels.required : undefined,
                })}
                name={`orderNumber[${index}].value`}
                label={labels.order_number}
                placeholder={labels.order_number_example}
                errorMessage={errors.orderNumber?.[index]?.value?.message}
                value={values?.[index]?.value}
                date-testid={`hcOrderId-${index}`}
              />
            </div>
          );
        })}
        <AddOrderNumberButton
          onClick={e => {
            e.preventDefault();
            appendOrderNumber({});
          }}
          data-testid="hcAddOrderButton"
        >
          <AddButtonIcon size={IconSize.XS} asset={GenericIconName.IcAdd} />
          {labels.add_order}
        </AddOrderNumberButton>
      </FormSection>
    </>
  );
};
